import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { CatalogueTiles } from "@/components/CatalogueTiles";
import { ProductCard } from "@/components/ProductCard";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";

export default function Home() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    api.get("/products", { params: { category: "nouveautes" } }).then(({ data }) => setProducts(data.slice(0, 4))).catch(() => {});
  }, []);

  return (
    <main>
      <Hero />
      <Marquee />
      <CatalogueTiles />

      <section className="py-24 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal className="flex items-end justify-between mb-12">
            <div>
              <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-blood mb-3">[ Drop 04 — Nocturne ]</p>
              <h2 className="font-syne font-extrabold uppercase tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-none">
                Les pièces<br />du moment
              </h2>
            </div>
            <Link
              to="/boutique?cat=nouveautes"
              data-testid="home-view-all-link"
              className="hidden sm:inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-smoke hover:text-volt transition-colors"
            >
              Tout voir <ArrowRight size={14} />
            </Link>
          </Reveal>
          <div data-testid="home-featured-grid" className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
            {products.map((p, i) => (
              <ProductCard key={p.id} product={p} index={i} />
            ))}
          </div>
          <div className="mt-10 text-center sm:hidden">
            <Link to="/boutique" className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-volt">
              Tout voir <ArrowRight size={14} />
            </Link>
          </div>
        </div>
      </section>

      <Marquee />
      <Manifesto />
      <Footer />
    </main>
  );
}
